import React from "react";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";
import { useState } from "react";
import InventoryTransformation from "./InventoryTransformation";
import InventoryTransformationTable from "./InventoryTransformationTable";
import { AnimatePresence } from "framer-motion";

const InventoryTransformationCard = () => {
  const [isCreate, setIsCreate] = useState(false);
  const [isChanged, setIsChanged] = useState(false);

  const handlePopup = () => {
    try {
      if (isCreate === true) {
        // clear();
      }
      setIsCreate(!isCreate);
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <>
      <CardHeadMenu
        prefix={"Na"}
        suffix={"Na"}
        title={"Inventory Transformation"}
        handlePopup={handlePopup}
        // isEdit={isEdit}
        create={isCreate}
        // showCreate={Boolean(is_super || is_admin || permissions?.includes(25))}
      />
      <AnimatePresence>
        {isCreate === true && (
          <InventoryTransformation
            isCreate={isCreate}
            setIsCreate={setIsCreate}
            isChanged={isChanged}
            setIsChanged={setIsChanged}
          />
        )}
      </AnimatePresence>
      <InventoryTransformationTable isChanged={isChanged} />
    </>
  );
};

export default InventoryTransformationCard;
